export const mainHtmlId: string = 'drag-and-drop-file';
